var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c(
        "div",
        { staticClass: "wl-content-container" },
        [
          _c("ul", { staticClass: "wl-tab" }, [
            _c(
              "li",
              {
                class: _vm.active === "1" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.handleClick("1")
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("newsMgt.kccNews")) +
                    "\n            "
                ),
              ]
            ),
            _c(
              "li",
              {
                class: _vm.active === "3" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.handleClick("3")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.materials")))]
            ),
            _c(
              "li",
              {
                class: _vm.active === "2" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.handleClick("2")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.usefulDocument")))]
            ),
          ]),
          _c("div", { staticClass: "wl-search-bar" }, [
            _c(
              "div",
              { staticClass: "wl-right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onEdit({})
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("COMMON_ADD")))]
                ),
                _c(
                  "el-upload",
                  {
                    staticClass: "template-uploader",
                    attrs: {
                      action: "url",
                      "http-request": _vm.uploadFiles,
                      "show-file-list": false,
                      "before-upload": _vm.beforeAvatarUpload,
                    },
                  },
                  [
                    _c("el-button", { staticClass: "wl-green svg-btn" }, [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-import.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(_vm._s(_vm.$t("COMMON_IMPORT"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.publish()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("newsMgt.publish")))]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { class: ["table-container-wrapper"] },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "wl-user-table",
                  attrs: {
                    height: "100%",
                    data: _vm.data,
                    border: "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      align: "center",
                      label: _vm.$t("newsMgt.seq"),
                      width: "80",
                      index: _vm.calcIndex,
                    },
                  }),
                  _vm._l(_vm.labelList, function (label, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        align: label.align || "center",
                        "show-overflow-tooltip":
                          label.showOverflowTooltip || false,
                        label: label.name,
                        width: label.width ? label.width + "px" : "",
                        "min-width": label.minWidth
                          ? label.minWidth + "px"
                          : "",
                        sortable: label.sortable,
                        prop: label.code,
                        fixed: label.fixed,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                label.picture
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex justify-center item-center",
                                      },
                                      [
                                        scope.row[label.code]
                                          ? _c("img", {
                                              attrs: {
                                                src: `data:image/png;base64,${
                                                  scope.row[label.code]
                                                }`,
                                                width: "120",
                                                height: "auto",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "el-upload",
                                          {
                                            ref: scope.row.id,
                                            refInFor: true,
                                            staticClass: "wl-icon-upload",
                                            attrs: {
                                              action: "",
                                              "http-request": (file) =>
                                                _vm.importImage(
                                                  file,
                                                  scope.row
                                                ),
                                              "show-file-list": false,
                                              "before-upload":
                                                _vm.beforeImageUpload,
                                              accept: "image/png, image/jpeg",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-upload",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : label.order
                                  ? _c(
                                      "div",
                                      [
                                        label.order
                                          ? _c("el-input-number", {
                                              attrs: {
                                                "controls-position": "right",
                                                min: 0,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.saveOrUpdate(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row[label.code],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    label.code,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row[label.code]",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(scope.row[label.code]) +
                                          "\n                        "
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: `${_vm.$t("newsMgt.status.1")}?`,
                      prop: "status",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                style: {
                                  color: _vm.renderStatusColor(
                                    scope.row.status
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(`newsMgt.status.${scope.row.status}`)
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    key: 9,
                    attrs: {
                      width: "170",
                      align: "center",
                      label: _vm.$t("TABLE_HEADER_Action"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _c("i", {
                                staticClass:
                                  "el-icon-edit-outline wl-icon-edit",
                                on: {
                                  click: function ($event) {
                                    return _vm.onEdit(scope.row)
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass: "el-icon-delete wl-icon-delete",
                                staticStyle: { "margin-left": "10px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(scope.row)
                                  },
                                },
                              }),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              "current-page": _vm.pagination.pageNum,
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next,sizes,total",
              total: _vm.pagination.total,
            },
            on: {
              "current-change": _vm.onCurrentPageChange,
              "size-change": _vm.onSizeChange,
            },
          }),
        ],
        1
      ),
      _vm.addVisible
        ? _c("NewsAdd", {
            attrs: {
              active: _vm.active,
              initData: _vm.initData,
              onCancel: _vm.cancelAddVisible,
              onAdd: _vm.saveOrUpdate,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }